import Image from 'next/image'
import React from 'react'

import { rewardFormat } from '@/libs/helpers/get-reward-currency'
import useUpToRewardLabel from '@/libs/logics/use-up-to-reward-label'
import { ERewardType, SURVEY_CATEGORY, SURVEY_PROVIDER } from '@/libs/types/global.types'

type TRewardDisplay = {
  rewardType: ERewardType
  rewardAmount: number
  surveyType: SURVEY_CATEGORY
  surveyProvider: SURVEY_PROVIDER
  useOwnLoyaltyPlatform?: boolean
  loyaltyPlatform?: {
    loyaltyPlatformIcon: string
    loyaltyPlatformName: string
    loyaltyPlatformPrefix?: string
    loyaltyPlatformSuffix?: string
  }
}

export default function RewardDisplay({
  rewardType,
  rewardAmount,
  surveyType,
  surveyProvider,
  useOwnLoyaltyPlatform,
  loyaltyPlatform,
}: TRewardDisplay) {
  const isUpToRewardLabel = useUpToRewardLabel({ surveyType, surveyProvider }) ? 'Up to ' : ''

  const { reward, prefix, suffix } = rewardFormat({
    useOwnLoyaltyPlatform,
    loyaltyPlatform,
    rewardType,
    rewardAmount,
    rewardPrefix: isUpToRewardLabel,
  })
  return rewardType ? (
    <div className='flex flex-row items-center gap-1'>
      {useOwnLoyaltyPlatform && loyaltyPlatform?.loyaltyPlatformIcon && (
        <Image
          src={loyaltyPlatform.loyaltyPlatformIcon}
          alt='loyalty-icon'
          height={18}
          width={18}
        />
      )}
      <h2 className='text-sm font-bold text-pop-gray-1'>
        {prefix}
        {reward} {suffix}
      </h2>
    </div>
  ) : null
}
